import React from "react"
import { FaSearch } from "react-icons/fa";
import SimpleBar from 'simplebar-react';
import { ProfessionList } from "./professionList";
 
export const SearchCategoryList = ({title}) => {
    const [search,setSearch] = React.useState('');

    return (
        <div className="category"> 
          <div className="search_category_nested">
            {title && <h3 className="category_title" >{title}</h3>}

            <div className="searching">
                <input 
                    name="" 
                    placeholder="Search category"
                    value={search}
                    onChange={e=>setSearch(e.target.value)}
                />
                <FaSearch />
            </div>
            <SimpleBar style={{ maxHeight:250 }}>

            <ProfessionList />

            </SimpleBar>
        </div>
       </div>
    )
}


